<template>
  <div>
    <b-form>
      <b-form-group id="exampleInputGroup1" label="Select groups" label-for="wp_adminurl">
        <v-select id="time_zone" :options="groups" :placeholder="'Type group name'" multiple :value="selectedGroups" :on-change="updateGroups"></v-select>
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
import _ from 'lodash';
import vSelect from 'vue-select';
export default {
  name: 'assigngroups',
  props: ['value'],
  components:{
    vSelect
  },
  data() {
    return {
      selectedGroups: []
    };
  },
  mounted() {
    this.selectedGroups = [];
    let groups = this.$store.getters.getGroups;
    _.each(this.value.groupIDs, groupID => {
      let group = _.find(groups, { groupID: groupID });
      if (group) {
        this.selectedGroups.push({ label: group.name, value: group.groupID });
      }
    });
    
  },
  computed: {
    groups() {
      return _.map(_.values(this.$store.getters.getGroups), group => {
        return { label: group.name, value: group.groupID };
      });
    }
  },
  methods: {
    updateGroups() {
      if (this.value) {
        this.value.groupIDs = _.map(this.selectedGroups, 'value');
        this.$emit('input', this.value);
      }
    }
  }
};
</script>

<style>
</style>
